import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "fourWheelDrive"
const FourWheelDriveIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M6.75 1.5C7.578 1.5 8.25 2.172 8.25 3V4.5H15.75V3C15.75 2.172 16.422 1.5 17.25 1.5H18.75C19.578 1.5 20.25 2.172 20.25 3V7.5C20.25 8.328 19.578 9 18.75 9H17.25C16.422 9 15.75 8.328 15.75 7.5V6H12.75V9.484C13.834 9.807 14.625 10.811 14.625 12S13.835 14.192 12.75 14.515V18H15.75V16.5C15.75 15.672 16.422 15 17.25 15H18.75C19.578 15 20.25 15.672 20.25 16.5V21C20.25 21.828 19.578 22.5 18.75 22.5H17.25C16.422 22.5 15.75 21.828 15.75 21V19.5H8.25V21C8.25 21.828 7.578 22.5 6.75 22.5H5.25C4.422 22.5 3.75 21.828 3.75 21V16.5C3.75 15.672 4.422 15 5.25 15H6.75C7.578 15 8.25 15.672 8.25 16.5V18H11.25V14.515C10.166 14.192 9.375 13.19 9.375 12S10.165 9.807 11.25 9.484V6H8.25V7.5C8.25 8.328 7.578 9 6.75 9H5.25C4.422 9 3.75 8.328 3.75 7.5V3C3.75 2.172 4.422 1.5 5.25 1.5zM5.25 21H6.75V16.5H5.25zM17.25 21H18.75V16.5H17.25zM12 10.875C11.714 10.875 11.454 10.982 11.255 11.158 11.022 11.364 10.875 11.665 10.875 12 10.875 12.333 11.021 12.63 11.25 12.836 11.45 13.016 11.711 13.125 12 13.125S12.55 13.015 12.75 12.836C12.98 12.63 13.125 12.333 13.125 12 13.125 11.664 12.977 11.364 12.745 11.158 12.544 10.982 12.284 10.875 12 10.875M5.25 7.5H6.75V3H5.25zM17.25 7.5H18.75V3H17.25z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default FourWheelDriveIcon
